import Edit from './Edit'


const def = {
  Edit,
}


export default def